import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataTransferService {

  private countries = new BehaviorSubject<any>([]);
  private userLocation = new BehaviorSubject<any>(null);
  private reloadEvent = new BehaviorSubject<number | null>(null);
  private reloadHeaderEvent = new BehaviorSubject<boolean | null>(null);

  sharedCountries = this.countries.asObservable();
  sharedUserLocation = this.userLocation.asObservable();
  sharedReloadEvent = this.reloadEvent.asObservable();
  sharedReloadHeaderEvent = this.reloadHeaderEvent.asObservable();


  constructor() { }

  nextCountries(countries: any) {
    this.countries.next(countries)
  }
  nextUserLocation(userLocation: any) {
    this.userLocation.next(userLocation)
  }
  nextReloadEvent(bInterval: number | any) {
    this.reloadEvent.next(bInterval)
  }
  nextReloadHeaderEvent(res: boolean | any) {
    this.reloadHeaderEvent.next(res)
  }

}
